const supplierBooking = {
    SupplierBookingStatus: {
        SupplierBookingStatusType: {
            Name: true,
            Caption: true,
            Color: true,
            LocalizedCaption: true,
        },
    },
    SupplierHotel: {
        Name: true,
        Hotel: {
            Address: true,
            HotelCategory: {
                Key: true,
                Caption: true,
                LocalizedCaption: true,
                RatingNumber: true,
            },
        },
        SupplierHotelImages: {
            Id: true,
            Caption: true,
            Feature: true,
            Published: true,
            HotelImageType: { Id: true, Key: true },
            VirtualPath: true,
        },
    },
    BookingCode: true,
    CheckInDate: true,
    CheckOutDate: true,
    BookingDate: true,
    Nights: true,
    Paxes: true,
    TotalAmount: true,
    Currency: {
        Key: true,
    },
    SupplierBookingPaymentInfo: {
        CreditCardNumberObfuscated: true,
        HolderName: true,
        HolderSurname: true,
        IdVirtualCreditCard: true,
        VirtualCreditCard: {
            CVV: true,
            CardNumber: true,
        },
    },
    ReservationIDs: {
        ResID_Value: true,
        OTAReferenceTableCode: {
            Key: true,
            Name: true,
        },
    },
    SupplierBookingRequest: true,
    Rooms: {
        SupplierHotelMealPlan: {
            Name: true,
            MappingCode: true,
        },
        SupplierHotelRoomType: {
            Name: true,
            Description: true,
            MappingCode: true,
        },
        Paxes: {
            Age: true,
            Name: true,
            Surname: true,
            IsAdult: true,
            IsBaby: true,
            IsChild: true,
        },
        Rates: {
            AmountAfterTax: true,
        },
        SupplierHotelRatePlan: {
            MappingCode: true,
            Name: true,
        },
    },
    Remarks: true,
    SupplierBookingCancellationPolicy: {
        DecodedPenalties: true,
    },
    ZoeBooking: {
        ExternalReferenceCodes: true,
        EndCustomer: {
            FullName: true,
            EmailAddress: true,
        },
    },
};

export default supplierBooking;
